'use strict';

module.exports = {
  IMPERIAL: 'imperial',
  METRIC: 'metric',
};
